/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import { gql } from '@apollo/client';

/* THEMES */
export const GET_All_THEMES = gql`
    query GetSite($domain_name: String, $fotograaf_id: ID) {
        site(domain_name: $domain_name, fotograaf_id: $fotograaf_id) {
            site_id
            title
            site_name
            domain_name
            first_category_ID
            theme {
                site_id
                logo
                favicon
                nav_position
                nav_menu_item_border_radius
                nav_background_menu_item
                nav_background_menu_item_hover
                nav_hover_text_color_menu_item
                primary_color_1
                primary_color_2
                primary_color_3
                primary_color_4
                primary_color_5
                primary_color_6
                primary_color_7
                background_color_1
                background_color_2
                background_color_3
                background_color_4
                background_color_5
                background_color_6
                background_color_7
                background_color_8
                cart_header_background
                cart_header_text
                nav_cart_icon_color
                font_family
                font_family_title
                font_family_link
                font_family_button
                company_image
                border_radius
                border_radius_2
                background_image
            }
            menus {
                naam
                hoofd_pagina_id
                pagina_id
                tekst
                url
                pagechildren {
                    naam
                    hoofd_pagina_id
                    pagina_id
                    tekst
                    url
                }
            }
            siteconfig {
                site_id
                type
                fotoverhouding_marge
            }
            siteoptions {
                option_id
                option_value
                option_type
                option_name
                site_id
            }
            emails {
                naam
                email
            }
        }
    }
`;

/* PAGE */
export const GET_PAGE = gql`
    query GetPage($site_id: ID!, $url: String!) {
        page(site_id: $site_id, url: $url) {
            url
            tekst
            naam
            omschrijving
            sleutelwoorden
        }
    }
`;

/* MENU */
// export const GET_MENU = gql`
//     query Getmenu($site_id: ID!, $naam: String!){
//         menus(site_id: $site_id, naam: $naam){
//             url
//             tekst
//             naam
//         }
//     }`

/* PRODUCTS */
export const GET_ALL_PRODUCTS = gql`
    query GetPhotos(
        $login_name: [String]
        $site_id: ID
        $folder_id: ID
        $first: Int
        $page: Int
    ) {
        photos(
            login_name: $login_name
            site_id: $site_id
            folder_id: $folder_id
            first: $first
            page: $page
        ) {
            paginatorInfo {
                count
                total
                currentPage
                hasMorePages
            }
            data {
                id
                site_id
                user_id
                login_name
                file_name
                type
                class_id
                productcategory {
                    categorie_id
                    naam
                    afbeelding
                    uitgeklapt
                    bargains
                    volgorde
                    next_categorie
                    back_categorie
                }
                folder {
                    folder_id
                    folder_naam
                    school_logo
                    school_id
                    school_folder_naam
                    class_id
                    class_name
                    administratiekosten
                    type
                    foreign
                    photographer_id
                    verzendkosten_korting
                    verzendkostenvrij_per_post
                    school_verzendkosten_korting_tekst
                    uitlever_datum
                    productlist {
                        keuzeset_id
                        products {
                            product_id
                            productdetail {
                                folder_id
                                naam
                                prijs
                                kleuren
                                product_type
                                product_file
                                combivel_id
                                formaat
                                shippingcost
                                actie_prijs
                                actie_afbeelding
                                afdruk_type{
                                    name
                                }
                                actie_begin_datum
                                actie_eind_datum
                                quantum_aantal
                                quantum_perc
                                pakket_selectie_alle_inlogs
                                pakket_selectie
                                product_variation_groups {
                                    id
                                    name
                                    type
                                    product_variations {
                                        id
                                        name
                                        image
                                        type
                                    }
                                }
                                effects {
                                    id
                                    png_src
                                    png_src_h
                                    voor_achter
                                }

                                productcategory {
                                    categorie_id
                                    naam
                                    bargains
                                    volgorde
                                    next_categorie
                                    back_categorie
                                }
                            }
                            productlink {
                                productpakketdetails {
                                    products {
                                        product_id
                                        productdetail {
                                            folder_id
                                            product_type
                                            product_format
                                            combivel_id
                                            shippingcost
                                            naam
                                            prijs
                                            kleuren
                                            product_file
                                            afbeelding
                                            youtube
                                            description
                                            actie_prijs
                                            afdruk_type{
                                                name
                                            }
                                            type
                                            actie_afbeelding
                                            actie_begin_datum
                                            actie_eind_datum
                                            quantum_aantal
                                            quantum_perc
                                            korting_pakketten_aantal
                                            korting_pakketten_perc
                                            productcategory {
                                                categorie_id
                                                naam
                                                next_categorie
                                                back_categorie
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_ALL_PHOTOGRAPHERS = gql`
    query photographer($fotograaf_id: ID!, $site_id: ID!) {
        photographer(fotograaf_id: $fotograaf_id, site_id: $site_id) {
            fotograaf_id
            site_id
            afbeelding
            primary_color_2
            primary_color_3
            background_color_1
            background_color_2
            background_color_3
            background_color_4
        }
    }
`;

export const GET_ALL_PRODUCTS_BY_PHOTO_ID = gql`
    query GetPhoto($photo_id: ID, $site_id: ID!, $login_name: [String]) {
        photo(id: $photo_id, site_id: $site_id, login_name: $login_name) {
            id
            previous_id
            user_id
            next_id
            site_id
            login_name
            file_name
            class_id
            school_id
            productcategory {
                categorie_id
                naam
                afbeelding
                omschrijving
                video
                uitgeklapt
                bargains
                next_categorie
                back_categorie
            }
            folder {
                folder_id
                folder_naam
                photographer_id
                school_folder_naam
                verzendkosten_korting
                school_verzendkosten_korting_tekst
                productlist {
                    keuzeset_id
                    products {
                        product_id
                        productlink {
                            productpakketdetails {
                                products {
                                    product_id
                                    productdetail {
                                        folder_id
                                        photo_id
                                        product_type
                                        product_format
                                        combivel_id
                                        verzendkosten
                                        naam
                                        prijs
                                        kleuren
                                        product_file
                                        afbeelding
                                        youtube
                                        description
                                        actie_prijs
                                        afdruk_type{
                                            name
                                        }
                                        type
                                        actie_afbeelding
                                        actie_begin_datum
                                        actie_eind_datum
                                        quantum_aantal
                                        quantum_perc
                                        korting_pakketten_aantal
                                        pakket_selectie_alle_inlogs
                                        pakket_selectie
                                        korting_pakketten_perc
                                        product_variation_groups {
                                            id
                                            name
                                            type
                                            product_variations {
                                                id
                                                name
                                                image
                                                type
                                            }
                                        }
                                        effects {
                                            id
                                            png_src
                                            png_src_h
                                            voor_achter
                                        }
                                        productcategory {
                                            categorie_id
                                            naam
                                            next_categorie
                                            back_categorie
                                        }
                                    }
                                }
                            }
                        }
                        productdetail {
                            photo_id
                            folder_id
                            naam
                            prijs
                            kleuren
                            combivel_id
                            product_format
                            product_file
                            product_type
                            verzendkosten
                            pakket_selectie_alle_inlogs
                            pakket_selectie
                            actie_prijs
                            afdruk_type{
                                name
                            }                            
                            afbeelding
                            youtube
                            description
                            actie_afbeelding
                            actie_begin_datum
                            actie_eind_datum
                            quantum_aantal
                            quantum_perc
                            korting_pakketten_aantal
                            korting_pakketten_perc
                            product_variation_groups {
                                id
                                name
                                type
                                product_variations {
                                    id
                                    name
                                    type
                                    image
                                }
                            }
                            effects {
                                id
                                png_src
                                png_src_h
                                voor_achter
                            }
                            productcategory {
                                categorie_id
                                naam
                                next_categorie
                                back_categorie
                            }
                        }
                    }
                }
            }
        }
    }
`;

/* Downloads */
export const GET_DOWNLOAD = gql`
    query GetDownload($site_id: ID!, $hash: String!) {
        getDownload(site_id: $site_id, hash: $hash) {
            site_id
            hash
        }
    }
`;

export const GET_DOWNLOADS = gql`
    query GetDownloads($site_id: ID!, $login_name: String!) {
        getDownloads(site_id: $site_id, login_name: $login_name) {
            download_id
            bestelling_id
            filename
            hash
            photo_id
            folder_id
            product_naam
            product_formaat
        }
    }
`;

export const GET_CLASSES = gql`
    query getAlbums($site_id: ID!, $folder_id: ID!) {
        getAlbums(site_id: $site_id, folder_id: $folder_id) {
            folder_id
            folder_naam
            folderchildren {
                folder_id
                folder_naam
                folderchildren {
                    folder_id
                    folder_naam
                }
            }
        }
    }
`;

/* PHOTOS & ALBUMS */
export const GET_ALBUMS = gql`
    query GetAlbums(
        $site_id: ID!
        $parent_id: ID
        $first: Int!
        $page: Int!
        $orderBy: [OrderByClause!]
    ) {
        albums(
            site_id: $site_id
            parent_id: $parent_id
            first: $first
            page: $page
            orderBy: $orderBy
        ) {
            paginatorInfo {
                count
                total
                currentPage
                hasMorePages
            }
            data {
                folder_id
                folder_naam
                user_id
                site_id
                keuzeset_id
                first_photo_id
                first_file_name
                school_plaats
                school_contactpersoon
                uitlever_datum
                login_naam
                password
                authorization
                photos {
                    id
                    file_name
                    product_file
                    folder_id
                }
                folderchildren {
                    folder_id
                    folder_naam
                    parent_id
                    user_id
                    site_id
                    keuzeset_id
                    first_file_name
                    uitlever_datum
                    folderchildren {
                        folder_id
                        folder_naam
                        parent_id
                        user_id
                        site_id
                        keuzeset_id
                        first_file_name
                        uitlever_datum
                        photos {
                            id
                            file_name
                            product_file
                            folder_id
                        }
                    }
                }
            }
        }
    }
`;

// export const GET_ALL_ALBUMS = gql`
//   query GetAlbums($site_id: ID!) {
//     albums(site_id: $site_id) {
//       folder_id
//       folder_naam
//       first_file_name
//       authorization
//     }
//   }
// `;

export const GET_ALL_ALBUM_PHOTOS = gql`
    query albumPhotos($site_id: ID!, $folder_id: ID!) {
        albumPhotos(site_id: $site_id, folder_id: $folder_id) {
            id
            login_name
            folder_id
            file_name
            site_id
        }
    }
`;

export const GET_PHOTOS_FROM_ALBUM = gql`
    query albumPhotos($site_id: ID!, $folder_id: ID!, $hoofdfoto: ID!) {
        albumPhotos(
            site_id: $site_id
            folder_id: $folder_id
            hoofdfoto: $hoofdfoto
        ) {
            id
            folder_id
            type
            login_name
            student_id
            kind_naam
            extra_email
            site_id
            user_id
            file_name
            inlogkaartje_gemaild_datum
            verstuur_inlogkaartje_mail
            afgeschermd
            hoofdfoto
            student_id
            voornaam
            tussenvoegsel
            achternaam
            email
            login_link
            datum_toegevoegd
            photochildren {
                id
                folder_id
                type
                login_name
                student_id
                kind_naam
                extra_email
                site_id
                user_id
                file_name
                inlogkaartje_gemaild_datum
                verstuur_inlogkaartje_mail
                afgeschermd
                hoofdfoto
                student_id
                voornaam
                tussenvoegsel
                achternaam
                email
                datum_toegevoegd
            }
            folder {
                folder_id
                keuzeset_id
                folder_naam
                folderparent {
                    folder_id
                    keuzeset_id
                    folder_naam
                    folderparent {
                        folder_id
                        keuzeset_id
                        folder_naam
                        sync
                        folderchildren {
                            folder_id
                            keuzeset_id
                            folder_naam
                            sync
                        }
                    }
                }
            }
        }
    }
`;

export const UPDATE_IMAGE = gql`
    mutation updateSchoolPhoto($input: SchoolPhotoInput) {
        updateSchoolPhoto(input: $input) {
            id
            site_id
            folder_id
            student_id
            login_name
            email
            extra_email
            file_name
            type
            kind_naam
            voornaam
            tussenvoegsel
            achternaam
            afgeschermd
            datum_toegevoegd
            verstuur_inlogkaartje_mail
            __typename
            photochildren {
                id
                hoort_bij_id
                file_name
            }
        }
    }
`;

/* PRODUCT CATEGORY */
export const GET_ALL_PRODUCT_CATEGORYS = gql`
    query GetProductcategorys(
        $site_id: ID!
        $keuzeset_id: ID!
        $catproducts: String
    ) {
        productcategorys(
            site_id: $site_id
            keuzeset_id: $keuzeset_id
            catproducts: $catproducts
            orderBy: [{ field: "volgorde", order: ASC }]
        ) {
            naam
            categorie_id
            afbeelding
            volgorde
            uitgeklapt
            catproducts {
                product_id
                naam
                formaat
                product_format
                prijs
                actie_prijs
                shippingcost
            }
        }
    }
`;

export const GET_FOLDER = gql`
    query albumList($site_id: ID!, $type: String!, $folder_naam: String!) {
        albumList(site_id: $site_id, type: $type, folder_naam: $folder_naam) {
            keuzeset_id
            folder_id
            user_id
        }
    }
`;

// export const GET_CATEGORY_WITH_PRODUCTS = gql`
//     query GetProductcats($categorie_id: ID!, $keuzeset_id: ID!){
//         productcats(
//             categorie_id: $categorie_id
//             keuzeset_id: $keuzeset_id
//         ){
//             categorie_id
//             naam
//             prijs
//             kleuren
//             product_format
//             product_file
//             product_type
//             shippingcost
//             actie_prijs
//             afbeelding
//             youtube
//             description
//             actie_afbeelding
//             actie_begin_datum
//             actie_eind_datum
//         }
//     }
// `

export const GET_CATEGORY_WITH_PRODUCTS = gql`
    query productcategorybybargains(
        $bargains: ID!
        $site_id: ID!
        $orderBy: [OrderByClause!]
    ) {
        productcategorybybargains(
            bargains: $bargains
            site_id: $site_id
            orderBy: $orderBy
        ) {
            naam
            categorie_id
            afbeelding
            omschrijving
            volgorde
            catproducts {
                product_id
                naam
                prijs
                kleuren
                product_format
                formaat
                product_file
                product_type
                shippingcost
                verzendkosten
                actie_prijs
                afbeelding
                youtube
                description
                actie_afbeelding
                actie_begin_datum
                actie_eind_datum
            }
        }
    }
`;

/* ADVERTISEMENTS */
export const GET_ADVERTISEMENT = gql`
    query GetProductAdvertisement($site_id: ID!, $keuzeset_id: ID!) {
        advertisement(site_id: $site_id, keuzeset_id: $keuzeset_id) {
            products {
                product_id
                productdetail {
                    naam
                    prijs
                    kleuren
                    product_file
                    actie_prijs
                    actie_afbeelding
                    actie_begin_datum
                    actie_eind_datum
                    quantum_perc
                    quantum_aantal
                    korting_pakketten_aantal
                    korting_pakketten_perc
                    productcategory {
                        categorie_id
                        naam
                    }
                }
            }
        }
    }
`;

export const GET_ADVERTISEMENT_BY_KEUZESETID = gql`
    {
        products(keuzeset_id: 1192) {
            product_id
            productdetail {
                naam
                prijs
                kleuren
                product_file
                actie_prijs
                actie_afbeelding
                actie_begin_datum
                actie_eind_datum
                productcategory {
                    categorie_id
                    naam
                }
            }
        }
    }
`;

/* PHOTO BACKGROUND EFFECT */
export const PHOTO_BACKGROUND_EFFECT = gql`
    query effects($site_id: ID!, $user_id: ID!, $product_id: ID) {
        effects(site_id: $site_id, user_id: $user_id, product_id: $product_id) {
            id
            user_id
            site_id
            naam
            png_src
            type
            voor_achter
        }
    }
`;
//
// /* PLACE ORDERS */
// export const ADD_TO_ORDERS = gql`
//     mutation createOrder(
//         $site_id: ID!
//         $user_id: ID!
//         $klant_naam: String!
//         $klant_voornaam: String!
//         $klant_achternaam: String!
//         $klant_adres: String!
//         $klant_straat: String!
//         $klant_huisnummer: String!
//         $klant_postcode: String!
//         $klant_plaats: String!
//         $klant_land: String!
//         $klant_telnr: String!
//         $klant_email: String!
//     ){
//         createOrder(
//             site_id: $site_id
//             user_id: $user_id
//             volgnr: 1
//             klant_naam: $klant_naam
//             klant_voornaam: $klant_voornaam
//             klant_achternaam: $klant_achternaam
//             klant_adres: $klant_adres
//             klant_straat: $klant_straat
//             klant_huisnummer: $klant_huisnummer
//             klant_postcode: $klant_postcode
//             klant_plaats: $klant_plaats
//             klant_land: $klant_land
//             klant_telnr: $klant_telnr
//             klant_email: $klant_email
//         ) {
//             bestelling_id
//             klant_email
//         }
//     }
// `;

export const GET_ORDERS = gql`
    query getOrder($site_id: ID!, $user_id: ID!, $sfg_login_code: String) {
        getOrder(
            site_id: $site_id
            user_id: $user_id
            sfg_login_code: $sfg_login_code
        ) {
            bestelling_id
            folder_id
            product_id
            sfg_login_code
            foto_id
            opmerkingen
            product_type
            product_naam
            bestelling_regel_id
            site_id
            aantal
            product_naam
            product_formaat
            product_categorie
            effect
            afbeelding_bestand
            oorspronkelijke_prijs_ps
            prijs_ps
            totaalprijs
        }
    }
`;

export const CREATE_ORDERS = gql`
    mutation createOrder(
        $site_id: ID!
        $user_id: ID!
        $session_id: ID!
        $klant_naam: String!
        $klant_voornaam: String!
        $customer_preposition: String
        $klant_achternaam: String!
        $klant_straat: String
        $klant_huisnummer: String
        $customer_house_number_suffix: String
        $klant_postcode: String
        $klant_plaats: String
        $klant_land: String
        $klant_telnr: String
        $klant_email: String!
        $klant_oudste_kind: String
        $klant_oudste_kind_klas: String
        $shippingcost_type: String
        $administratiekosten: String
        $newsletter: String
        $opmerking: String
        $school_id: ID
        $school_naam: String
        $share_social_media: String
    ) {
        createOrder(
            input: {
                site_id: $site_id
                user_id: $user_id
                session_id: $session_id
                klant_naam: $klant_naam
                klant_voornaam: $klant_voornaam
                customer_preposition: $customer_preposition
                klant_achternaam: $klant_achternaam
                klant_straat: $klant_straat
                klant_huisnummer: $klant_huisnummer
                customer_house_number_suffix: $customer_house_number_suffix
                klant_postcode: $klant_postcode
                klant_plaats: $klant_plaats
                klant_land: $klant_land
                klant_telnr: $klant_telnr
                klant_oudste_kind: $klant_oudste_kind
                klant_oudste_kind_klas: $klant_oudste_kind_klas
                klant_email: $klant_email
                shippingcost_type: $shippingcost_type
                administratiekosten: $administratiekosten
                newsletter: $newsletter
                opmerking: $opmerking
                school_id: $school_id
                school_naam: $school_naam
                share_social_media: $share_social_media
                order_rules: {
                    foto_id: 13
                    product_id: 13
                    site_id: 15
                    product_naam: "test"
                    product_formaat: "20x20"
                    product_categorie: "Foto"
                    foto_bestand: "asa"
                    oorspronkelijke_prijs_ps: "12"
                    prijs_ps: "12"
                    aantal: 12
                    effect: "323"
                    totaalprijs: 122
                    opmerkingen: "testopmerking"
                }
            }
        ) {
            bestelling_id
            klant_naam
            klant_land
            order_rules {
                foto_id
                opmerkingen
            }
        }
    }
`;

export const UPDATE_ORDER_STATUS = gql`
    mutation updateOrder($site_id: ID!, $user_id: ID!, $bestelling_id: ID!) {
        updateOrder(input: { bestelling_id: $bestelling_id, status: "betaald" }) {
            bestelling_id
        }
    }
`;
/* POSTCODE CHECKER */

export const GET_ADDRESS = gql`
    mutation getAddressByZipcode($zipcode: String!, $housenumber: String!) {
        getAddressByZipcode(zipcode: $zipcode, housenumber: $housenumber) {
            street
            city
            error
            houseAddition
        }
    }
`;
export const GET_ZIPCODE = gql`
    mutation getAddressByZipcode($zipcode: String!, $housenumber: String!) {
        getAddressByZipcode(
            input: { zipcode: $zipcode, housenumber: $housenumber }
        ) {
            street
            city
        }
    }
`;

/* USER */
export const LOGIN_USER = gql`
    mutation login(
        $v2: String
        $login_name: String!
        $login_password: String!
        $client_secret: String!
        $site_id: ID!
        $album_id: ID
    ) {
        login(
            data: {
                v2: $v2
                username: $login_name
                password: $login_password
                client_id: 2
                client_secret: $client_secret
                site_id: $site_id
                album_id: $album_id
            }
        ) {
            user {
                id
                email
            }
            access_token
            refresh_token
            login_password
            login_name
            expires_in
            status
        }
    }
`;

export const CREATE_USER = gql`
    mutation register(
        $email: String!
        $password: String!
        $name: String!
        $firstname: String
        $middlename: String
        $lastname: String
    ) {
        register(
            data: {
                name: $name
                firstname: $firstname
                middlename: $middlename
                lastname: $lastname
                email: $email
                password: $password
                client_id: 2
                client_secret: "lWUHvnbqpAt6bbh6kfkHpIOVDVp7IGeRzg4d5Pmp"
            }
        ) {
            id
            name
            firstname
            middlename
            lastname
            email
        }
    }
`;

export const CREATE_USERS_ACCOUNT = gql`
    mutation registerAccount(
        $login_name: String!
        $email: String!
        $password: String!
        $roles: String!
        $site_id: ID
    ) {
        registerAccount(
            data: {
                login_name: $login_name
                email: $email
                password: $password
                client_id: 2
                client_secret: "lWUHvnbqpAt6bbh6kfkHpIOVDVp7IGeRzg4d5Pmp"
                roles: $roles
                site_id: $site_id
            }
        ) {
            name
            email
            login_password
        }
    }
`;
export const MATCH_TICKET_TO_ACCOUNT = gql`
    mutation registerTicketToAccount($input: RegisterTicketAccountInput) {
        registerTicketToAccount(input: $input) {
            login_name
            status
            message
        }
    }
`;

/* PASSWORD */
export const FORGOT_PASSWORD = gql`
    mutation forgotPassword(
        $email: String!
        $client_secret: String!
        $client_id: Int!
    ) {
        forgotPassword(
            data: {
                email: $email
                client_id: $client_id
                client_secret: $client_secret
            }
        ) {
            status
            message
        }
    }
`;

export const UPDATE_PASSWORD = gql`
    mutation updateForgottenPassword(
        $email: String!
        $client_secret: String!
        $client_id: Int!
        $token: String!
        $password: String!
        $password_confirmation: String!
    ) {
        updateForgottenPassword(
            data: {
                email: $email
                client_id: $client_id
                client_secret: $client_secret
                token: $token
                password: $password
                password_confirmation: $password_confirmation
            }
        ) {
            status
            message
        }
    }
`;

/*klassen ouste kind */
export const CLASSES_OF_SCHOOL = gql`
    query classesofschool($id: ID, $login_name: String!) {
        classesofschool(id: $id, login_name: $login_name) {
            folder_id
            folder_name
        }
    }
`;

export const SHIPPING_METHODS = gql`
    query shippingmethods($site_id: ID!, $shippingcost_type: String) {
        shippingmethods(site_id: $site_id, shippingcost_type: $shippingcost_type) {
            shipping_method_name
            shipping_method_cost
            shipping_method_value
        }
    }
`;

/* SHOPPINGCART */

export const GET_SHOPPINGCART = gql`
    query shoppingcart(
        $session_id: ID!
        $site_id: ID!
        $login_name: [login_name!]
        $shipping_method: String
    ) {
        shoppingcart(
            session_id: $session_id
            site_id: $site_id
            login_name: $login_name
            shipping_method: $shipping_method
        ) {
            id
            shipping_method
            cart_session_id
            totaal
            subtotaal
            tax
            discount
            discount_code
            discount_message
            shippingcost
            shippingcost_type
            shippingcost_type_name
            type
            administrationcosts
            amount_products
            pay_school
            cartproducts {
                id
                product_id
                product_type
                photo_info {
                    id
                    file_name
                    folder_id
                }
                products {
                    product_id
                    product_name
                    product_type
                    product_image
                    product_file_name
                    format
                    product_file
                }
                subproducten {
                    photo_info {
                        id
                        file_name
                        folder_id
                    }
                    products {
                        product_id
                        product_name
                        product_type
                        product_image
                        product_file_name
                        format
                        product_file
                    }
                    combivel_id
                    effect_file_name
                    effect_file_name_for
                    effect_file_id
                    effect_file_id_for
                    product_variation
                    image_effect
                }
                combivel_id
                effect_file_name
                effect_file_name_for
                effect_file_id
                effect_file_id_for
                image_effect
                product_variation
                discount_price
                amount
                org_totaal_prijs
                org_stuks_prijs
                oud_prijs
                korting_prijs
                stuks_price
                total_price
                korting_pakketten_aantal
                korting_pakketten_perc
                quantum_aantal
                quantum_perc
            }
            status
            message
        }
    }
`;

export const DELETE_DISCOUNT_UPDATE_CART = gql`
    mutation deleteDiscountCodes(
        $id: ID!
        $session_id: ID!
        $discount_code: String
    ) {
        updateShoppingcart(
            id: $id
            session_id: $session_id
            discount_code: $discount_code
        ) {
            id
        }
    }
`;

export const ADD_TO_CART = gql`
    mutation createShoppingcart($input: [ShoppingCartInput!]) {
        createShoppingcart(input: $input) {
            cart_session_id
            session_id
            site_id
            login_name
            combivel_id
            product_id
            photo_id
            image_effect
            amount
            message
        }
    }
`;

export const UPDATE_SHOPPINGCART = gql`
    mutation updateShoppingcart(
        $id: ID!
        $session_id: ID!
        $tax: String
        $subtotaal: String
        $totaal: String
        $discount: String
        $shippingcost_type: String
        $shippingcost_type_name: String
        $discount_code: String
    ) {
        updateShoppingcart(
            id: $id
            session_id: $session_id
            tax: $tax
            subtotaal: $subtotaal
            totaal: $totaal
            discount: $discount
            shippingcost_type: $shippingcost_type
            shippingcost_type_name: $shippingcost_type_name
            discount_code: $discount_code
        ) {
            session_id
            tax
            subtotaal
            totaal
            shippingcost_type
            shippingcost_type_name
            discount_code
        }
    }
`;

export const DELETE_ALL_FROM_SHOPPINGCART = gql`
    mutation deleteShoppingcart($session_id: ID!) {
        deleteShoppingcart(session_id: $session_id) {
            status
            message
        }
    }
`;

/* SHOPPINGCART PRODUCTS */
export const UPDATE_CARTPRODUCTS = gql`
    mutation updateCartProducts(
        $id: ID!
        $amount: ID
        $login_name: [String]
        $session_id: String
        $site_id: String
    ) {
        updateCartProducts(
            id: $id
            amount: $amount
            login_name: $login_name
            session_id: $session_id
            site_id: $site_id
        ) {
            id
            amount
        }
    }
`;

export const UPDATE_CARTPRODUCT = gql`
    mutation updateCartProduct(
        $id: ID!
        $cart_rules_id: ID!
        $product_id: ID!
        $newId: ID!
    ) {
        updateCartProduct(
            id: $id
            cart_rules_id: $cart_rules_id
            product_id: $product_id
            newId: $newId
        ) {
            id
            cart_rules_id
            product_id
            newId
        }
    }
`;

export const DELETE_CARTPRODUCTS = gql`
    mutation deleteCartProducts($id: ID!) {
        deleteCartProducts(id: $id) {
            id
        }
    }
`;

/* MODULES */
export const SHOW_MODULES = gql`
    query modules {
        modules {
            module_id
            module_naam
            tag
        }
    }
`;

/* MODULES */
export const SHOW_MODULE_OPTION_SETS = gql`
    query moduleoptionssets($user_id: ID!, $optie_id: ID!) {
        moduleoptionssets(user_id: $user_id, optie_id: $optie_id) {
            waarde
            user_id
            optie_id
            option_set_id
        }
    }
`;

export const SHOW_MODULE_OPTIONS_BY_MODULE_ID = gql`
    query module($module_id: ID!) {
        module(module_id: $module_id) {
            module_id
            module_naam
            tag
            moduleoptions {
                optie_id
                module_id
                naam
                tag
                omschrijving
                type_input
                default
            }
        }
    }
`;

export const SHOW_MODULES_BY_USERRIGHTS = gql`
    query moduleright($user_id: ID!, $module_id: ID!) {
        moduleright(user_id: $user_id, module_id: $module_id) {
            rechten_id
            module_id
            user_id
            modules {
                module_id
                module_naam
                tag
                moduleoptions {
                    optie_id
                    module_id
                    naam
                    tag
                    omschrijving
                    type_input
                    default
                }
            }
        }
    }
`;

// PAYMENT
// export const CREATE_PAYMENT = gql`
//     mutation CreatePayment($site_id: ID!,$type: String!, $trxid: String, $returnUrl: String, $order_id: Int!) {
//         createPayment(site_id: $site_id, type: $type, trxid: $trxid, returnUrl: $returnUrl,order_id: $order_id,amount: "15.00",currency: "EUR", description: "Ramon"){
//             checkoutUrl
//         }
//     }
// `;

export const CREATE_PAYMENT = gql`
    mutation CreatePayment(
        $site_id: ID!
        $type: String!
        $trxid: String
        $returnUrl: String
        $order_id: Int!
        $payment_step: String
        $session_id: String
        $payment_gateway: String
        $issuer: String
        $klant_rekeninghouder: String
        $klant_rekeningnummer: String
    ) {
        createPayment(
            site_id: $site_id
            type: $type
            trxid: $trxid
            returnUrl: $returnUrl
            session_id: $session_id
            order_id: $order_id
            currency: "EUR"
            payment_step: $payment_step
            payment_gateway: $payment_gateway
            issuer: $issuer
            klant_rekeningnummer: $klant_rekeningnummer
            klant_rekeninghouder: $klant_rekeninghouder
        ) {
            checkoutUrl
            payment_step
            session_id
            payment_gateway
            issuer
            options {
                id
                name
            }
        }
    }
`;

export const UPDATE_PAYMENT = gql`
    query UpdatePayment(
        $site_id: ID!
        $type: String!
        $trxid: String
        $returnUrl: String
        $session_id: String
        $payment_step: String
        $order_id: Int!
    ) {
        updatePayment(
            site_id: $site_id
            type: $type
            trxid: $trxid
            returnUrl: $returnUrl
            session_id: $session_id
            payment_step: $payment_step
            order_id: $order_id
            amount: "15.00"
            currency: "EUR"
        ) {
            checkoutUrl
            status
        }
    }
`;

// FILES
export const UPLOAD_FILE = gql`
    mutation SingleUpload(
        $file: Upload!
        $login_name: String!
        $login_email: String
        $site_id: ID!
        $folder_id: ID
    ) {
        singleUpload(
            file: $file
            login_name: $login_name
            login_email: $login_email
            site_id: $site_id
            folder_id: $folder_id
        ) {
            id
            filename
            mimetype
            encoding
            login_name
            folder_id
        }
    }
`;

export const UPLOAD_FILE_STREAM = gql`
    mutation SingleUploadStream($file: Upload!) {
        singleUploadStream(file: $file) {
            filename
            mimetype
            encoding
        }
    }
`;

// DISCOUNT
export const ADD_DISCOUNT_CODE = gql`
    mutation submitDiscount(
        $site_id: ID!
        $session_id: ID!
        $price: String!
        $discount_code: String!
    ) {
        submitDiscount(
            site_id: $site_id
            session_id: $session_id
            price: $price
            code: $discount_code
        ) {
            message
        }
    }
`;

// MESSAGES
export const CREATE_MESSAGE = gql`
    mutation createMessage(
        $user_id: ID
        $site_id: ID!
        $username: String
        $firstname_sender: String
        $lastname_sender: String
        $photo_id: String
        $email_sender: String
        $send_email_to: String
        $type: String
        $subject: String
        $message: String
    ) {
        createMessage(
            input: {
                user_id: $user_id
                site_id: $site_id
                username: $username
                firstname_sender: $firstname_sender
                lastname_sender: $lastname_sender
                photo_id: $photo_id
                email_sender: $email_sender
                send_email_to: $send_email_to
                type: $type
                subject: $subject
                message: $message
            }
        ) {
            id
            user_id
            site_id
            username
            firstname_sender
            lastname_sender
            email_sender
            send_email_to
            type
            subject
            message
        }
    }
`;

export const GET_ORDER_STATISTICS = gql`
    query orderStatistics($site_id: ID! $school_id: ID $is_site: String) {
        orderStatistics(site_id: $site_id school_id: $school_id is_site: $is_site) {
            totaal_inlogs
            aantal_inlogs
            gemiddeld
            bedrag
            verzendkosten
            bedrag_zonder_verzendkosten
            gemiddeld_bedrag
            bedrag_per_inlog
            gemiddeld_bedrag_per_uitgegeven_inlog
            extra_bedrag
            kosten
            cadeauverpakking
            spoedtoeslag
            btw
            korting
            ideal
            open
            betaald
            afgerond
            geannuleerd
            percentage_geannuleerd
            bestellingen
            show_turnover
            bedrag_zonder_btw_verzendkosten_zonder
            download_totaal_price
            top_three_products {
                product_name
                sales_count
            }
            discount_codes_uses {
                code
                count
            }
        }
    }
`;
